import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import { MediaQuery } from '@grandvisionhq/common';
import { Text } from '@grandvisionhq/elements';
import { Icon } from '@grandvisionhq/icons';
import { useIntl } from '@grandvisionhq/state';
import { StepWithAlerts } from '../components/StepWithAlerts/StepWithAlerts.js';
import { PupillaryDistanceContent } from '../PrescriptionStep/components/PupillaryDistanceContent/PupillaryDistanceContent.js';
import { PupillaryDistanceLinkContainer } from '../PrescriptionStep/components/PupillaryDistanceLink/PupillaryDistanceLinkContainer.js';
import { PrescriptionUploadFormContainer } from '../PrescriptionStep/components/PrescriptionUploadForm/PrescriptionUploadFormContainer.js';
import { PRESCRIPTION_STEP_UPLOAD_DESCRIPTION_ID } from '../../../state/constants.js';

var PrescriptionUploadStep = (_param)=>{
    var { description , image  } = _param, stepWithAlertsProps = swcHelpers.objectWithoutProperties(_param, [
        "description",
        "image"
    ]);
    const isPhone = MediaQuery.useIsPhone();
    const { getLabel , getFormattedLabel  } = useIntl();
    const supportedFilesLabelKey = 'products.glasses.upload.supportedFileTypes';
    const privacyPolicyLabelValue = getFormattedLabel('products.glasses.upload.privacyPolicyLink', {
        parseLink: true,
        openLinksInNewTab: true
    });
    const hasExtraInfo = Boolean(description || image);
    return /*#__PURE__*/ React__default.createElement(StepWithAlerts, swcHelpers.extends({}, stepWithAlertsProps), /*#__PURE__*/ React__default.createElement("div", {
        className: "rx-upload-step"
    }, hasExtraInfo && /*#__PURE__*/ React__default.createElement(PupillaryDistanceContent, {
        description: description,
        image: image
    }), !hasExtraInfo && isPhone && /*#__PURE__*/ React__default.createElement(PupillaryDistanceLinkContainer, null), /*#__PURE__*/ React__default.createElement(PrescriptionUploadFormContainer, {
        className: "rx-upload-step__upload-form"
    }), /*#__PURE__*/ React__default.createElement(Text, {
        id: PRESCRIPTION_STEP_UPLOAD_DESCRIPTION_ID
    }, getLabel(supportedFilesLabelKey)), !hasExtraInfo && !isPhone && /*#__PURE__*/ React__default.createElement(PupillaryDistanceLinkContainer, null), /*#__PURE__*/ React__default.createElement("div", {
        className: "rx-upload-step__privacy"
    }, /*#__PURE__*/ React__default.createElement(Icon, {
        name: "info"
    }), /*#__PURE__*/ React__default.createElement(Text, null, privacyPolicyLabelValue))));
};

export { PrescriptionUploadStep };
//# sourceMappingURL=PrescriptionUploadStep.js.map
